// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aE0tq","question":"styles_question__3i3BK","inputVisibleButton":"styles_inputVisibleButton__2bfwK","note":"styles_note__1cwdk"};